import api from "api";
import { useMutation } from "react-query";
import { useId } from "utils/hooks";

const useDeletePOC = () => {
  const patientId = useId();
  return useMutation((id: number) => api("DELETE /patients/{patient_id}/care_plans/{id}", [patientId, id]));
};

export default useDeletePOC;
